/* eslint-disable camelcase */
import { type FC, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { useFixBackground } from "@root/shared/hooks/useFixBackground";
import { type SiteId } from "@root/shared/types/type";
import { type SecondarySearchHitCassettes } from "@userFrontend/features/publication/types/Cassettes";
import { useWorkDetailOtherWorkCassettes } from "./useWorkDetailOtherWorkCassettes";
import { Presentation } from "./Presentation";

type Props = {
  initialClientOtherWorks: SecondarySearchHitCassettes;
  totalCount: number;
  secondaryContentAsync: {
    url: string;
    params: {
      aggregate_key: string;
      site_id: SiteId;
      query_string: string;
      searched_employments: string[];
      search_instance_attributes: Record<string, string | number>;
      exclude_work_id: number;
    };
  };
  brandName: string;
  businessType: string;
  occupation: string;
  workCode: string;
};

export const WorkDetailOtherWorkCassettes: FC<Props> = ({
  initialClientOtherWorks,
  totalCount,
  secondaryContentAsync: { url, params },
  brandName,
  businessType,
  occupation,
  workCode,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { ref: indicatorRef, inView: indicatorInview } = useInView();
  const { shops, fetchWorks, isShowIndicator } = useWorkDetailOtherWorkCassettes({
    initialClientOtherWorks,
    url,
    params,
    totalNumber: totalCount,
  });
  const { fixBody, unFixBody } = useFixBackground();

  const handleOpenModal = () => {
    setIsOpenModal(true);
    fixBody();
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
    unFixBody();
  };

  // 追加で求人を取得
  useEffect(() => {
    if (indicatorInview) {
      fetchWorks();
    }
    // fetchWorksを含めるとループしてしまうので除外する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indicatorInview]);

  if (shops.length < 1) return null;

  return (
    <Presentation
      workCode={workCode}
      shops={shops}
      isOpenModal={isOpenModal}
      totalCount={totalCount}
      handleOpenModal={handleOpenModal}
      handleCloseModal={handleCloseModal}
      brandName={brandName}
      businessType={businessType}
      occupation={occupation}
      isShowIndicator={isShowIndicator}
      indicatorRef={indicatorRef}
    />
  );
};
